var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDelete = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.893,
    height: 23.101,
    viewBox: "0 0 18.893 23.101",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1496"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 374",
    d: "M1.046 13.273V7.444a1.053 1.053 0 1 1 2.1-.16c.006.09 0 .18 0 .271v11.338a2.007 2.007 0 0 0 2.1 2.1h8.385a2.008 2.008 0 0 0 2.108-2.12V7.436a1.06 1.06 0 0 1 .792-1.1 1.039 1.039 0 0 1 1.288.856 2.139 2.139 0 0 1 .021.343v11.387a4.105 4.105 0 0 1-3.444 4.117 4.214 4.214 0 0 1-.734.058q-4.218.006-8.434 0a4.117 4.117 0 0 1-4.185-4.194l.003-5.63z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 375",
    d: "M5.252 3.151V1.202a1.71 1.71 0 0 1 .041-.438A1.025 1.025 0 0 1 6.321.005q3.122-.009 6.244 0a1.032 1.032 0 0 1 1.07 1.1c.006.582 0 1.164 0 1.746v.3h4.092a1.1 1.1 0 0 1 .867.332 1 1 0 0 1 .21 1.116 1.017 1.017 0 0 1-.906.653c-.057.005-.115 0-.172 0H1.165a1.055 1.055 0 1 1-.026-2.1h3.786zm2.1-.016h4.178v-1.01H7.352z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 376",
    d: "M6.297 13.128V9.441a1.043 1.043 0 0 1 1.991-.431 1.3 1.3 0 0 1 .1.5q.01 3.613 0 7.227a1.052 1.052 0 1 1-2.1-.019q.006-1.796.009-3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 377",
    d: "M12.593 13.124v3.663a1.031 1.031 0 0 1-.768 1.02 1 1 0 0 1-1.164-.46 1.33 1.33 0 0 1-.162-.605q-.016-3.613-.005-7.227a1.052 1.052 0 1 1 2.1.021q.002 1.793-.001 3.588z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDelete);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-delete.a2a8e2c0b3b2a7110832ae268d09d185.svg";